import { PDFDocument } from "pdf-lib";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const yyyy = date.getFullYear();
  const mm = `${date.getMonth() + 1}`.padStart(2, "0");
  const dd = `${date.getDate()}`.padStart(2, "0");
  return `${yyyy}${mm}${dd}`;
};

const formatDateOnly = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return (
    `${date.getDate()}`.padStart(2, "0") +
    "/" +
    `${date.getMonth() + 1}`.padStart(2, "0") +
    "/" +
    date.getFullYear()
  );
};

export const handleDownloadPrefilledPDF = async (
  patient,
  returnBlob = false
) => {
  const formUrl = "/patient-entry-form.pdf";
  const existingPdfBytes = await fetch(formUrl).then((res) =>
    res.arrayBuffer()
  );
  const pdfDoc = await PDFDocument.load(existingPdfBytes);

  const form = pdfDoc.getForm();

  

  const field = (name) => {
    try {
      return form.getTextField(name);
    } catch {
      return null;
    }
  };

  const mainmale = form.getCheckBox("Check Box1");
  const mainfemale = form.getCheckBox("Check Box2");
  const mainemailstatementsyes = form.getCheckBox("Check Box3");
  const mainemailstatementsno = form.getCheckBox("Check Box4");
  const mainmedicalgapcoveryes = form.getCheckBox("Check Box5");
  const mainmedicalgapcoverno = form.getCheckBox("Check Box6");
  const patientmale = form.getCheckBox("Check Box7");
  const patientfemale = form.getCheckBox("Check Box8");

  const patientuseappointtestresultsyes = form.getCheckBox("Check Box9");
  const patientuseappointtestresultsno = form.getCheckBox("Check Box10");

  if (mainmale) patient.main_male ? mainmale.check() : mainmale.uncheck();
  if (mainfemale)
    patient.main_female ? mainfemale.check() : mainfemale.uncheck();

  if (patientmale)
    patient.patient_male ? patientmale.check() : patientmale.uncheck();
  if (patientfemale)
    patient.patient_female ? patientfemale.check() : patientfemale.uncheck();

  if (patient.main_email_statements === true) {
    mainemailstatementsyes?.check();
    mainemailstatementsno?.uncheck();
  } else if (patient.main_email_statements === false) {
    mainemailstatementsyes?.uncheck();
    mainemailstatementsno?.check();
  }

  if (patient.main_medical_gap_cover === true) {
    mainmedicalgapcoveryes?.check();
    mainmedicalgapcoverno?.uncheck();
  } else if (patient.main_medical_gap_cover === false) {
    mainmedicalgapcoveryes?.uncheck();
    mainmedicalgapcoverno?.check();
  }

  if (patient.patient_use_appoint_test_results === true) {
    patientuseappointtestresultsyes?.check();
    patientuseappointtestresultsno?.uncheck();
  } else if (patient.patient_use_appoint_test_results === false) {
    patientuseappointtestresultsyes?.uncheck();
    patientuseappointtestresultsno?.check();
  }

  const today = new Date();
  const todayFormatted = `${today.getFullYear()}${String(
    today.getMonth() + 1
  ).padStart(2, "0")}${String(today.getDate()).padStart(2, "0")}`;

  if (!patient) return;

  const fieldsMap = {
    "ID NOMMER": (patient?.main_identification_number || "").substring(0, 13),
    VAN: patient?.main_surname || "",
    "VOLLE NAME": patient?.main_full_names || "",
    VOORLETTERS: (patient.main_initials || "").substring(0, 4),
    "Check Box1": patient?.main_male ? "Yes" : "",
    "Check Box2": patient?.main_female ? "Yes" : "",
    TITEL: patient?.main_title || "",
    Text1: (formatDate(patient?.main_date_of_birth) || "").substring(0, 8),
    "HUISTAAL.0": patient?.main_employer || "",
    SELNOMMER: (patient?.main_cell_number || "").slice(0, 3),
    undefined: (patient?.main_cell_number || "").slice(3, 10),
    "HUIS NOMMER": (patient?.main_home_number || "").slice(0, 3),
    undefined_2: (patient?.main_home_number || "").slice(3, 10),
    "WERK NOMMER": (patient?.main_work_number || "").slice(0, 3),
    undefined_3: (patient?.main_work_number || "").slice(3, 10),
    "FAKS NOMMER": (patient?.main_fax_number || "").slice(0, 3),
    "undefined_4.0": (patient?.main_fax_number || "").slice(3, 10),
    "E POS ADRES": patient?.main_email_address || "",
    POSADRES: patient?.main_postal_address_1 || "",
    undefined_5: patient?.main_postal_address_2 || "",
    undefined_6: patient?.main_postal_address_3 || "",
    POSKODE: (patient?.main_postal_address_code || "").substring(0, 4),
    "FISIESE ADRES": patient?.main_physical_address_1 || "",
    undefined_7: patient?.main_physical_address_2 || "",
    undefined_8: patient?.main_physical_address_3 || "",
    POSKODE_2: (patient?.main_physical_address_code || "").substring(0, 4),
    "MEDIESE FONDS": patient?.main_medical_scheme || "",
    PLANOPSIE: patient?.main_medical_scheme_plan || "",
    undefined_9: (patient?.main_medical_member_number || "").substring(0, 19),
    "HOOFLID AFHANKLIKE KODE": (
      patient?.main_medical_member_main_dep_code || ""
    ).substring(0, 2),
    "ID NOMMER_2": (patient?.patient_identification_number || "").substring(
      0,
      13
    ),
    VAN_2: patient?.patient_surname || "",
    "VOLLE NAME_2": patient?.patient_full_names || "",
    NOEMNAAM: patient?.patient_nick_names || "",
    VOORLETTERS_2: (patient?.patient_initials || "").substring(0, 4),
    TITEL_2: patient?.patient_title || "",
    Text2: (formatDate(patient?.patient_date_of_birth) || "").substring(0, 8),
    SELNOMMER_2: (patient?.patient_cell_number || "").slice(0, 3),
    undefined_10: (patient?.patient_cell_number || "").slice(3, 10),
    "HUIS NOMMER_2": (patient?.patient_home_number || "").slice(0, 3),
    undefined_11: (patient?.patient_home_number || "").slice(3, 10),
    "WERK NOMMER_2": (patient?.patient_work_number || "").slice(0, 3),
    "Hooflid se selnommer sal gebruik word as bostaande Nee is": (
      patient?.patient_work_number || ""
    ).slice(3, 10),
    "E POS ADRES_2": patient?.patient_email_address || "",
    undefined_12: patient?.patient_occupation || "",
    undefined_13: patient?.patient_marital_status || "",
    "VERWANTSKAP AAN HOOFLID": patient?.patient_relationship_main || "",
    "AFHANKLIKE KODE": (patient?.patient_dep_code || "").substring(0, 2),
    OUDERDOM: (String(patient?.patient_age) || "").slice(0, 2),
    LENGTE: (patient?.patient_height || "").slice(0, 1),
    undefined_14: (patient?.patient_height || "").slice(1, 3),
    GEWIG: (String(patient?.patient_weight) || "").slice(0, 3),
    "VERWYSENDE DR": patient?.patient_referring_doctor || "",
    HUISDOKTER: patient?.patient_gp || "",
    TEL: (patient?.patient_referring_doctor_nuiber || "").slice(0, 3),
    undefined_15: (patient?.patient_referring_doctor_nuiber || "").slice(3, 10),
    "TEL NOMMER": (patient?.patient_gp_number || "").slice(0, 3),
    "undefined_4.1": (patient?.patient_gp_number || "").slice(3, 10),
    VOORLETTERS_3: (patient.next_kin_initials || "").substring(0, 4),
    TITEL_3: patient?.next_kin_title || "",
    VAN_3: patient?.next_kin_surname || "",
    "VOLLE NAME_3": patient?.next_kin_full_names || "",
    SELNOMMER_3: (patient?.next_kin_cell_number || "").slice(0, 3),
    undefined_16: (patient?.next_kin_cell_number || "").slice(3, 10),
    "VERWANTSKAP AAN PASIENT": patient?.next_kin_relationship || "",
    "NAAM IN DRUKSKRIF": (patient?.main_full_names || "").substring(0, 19),
    Text3: todayFormatted,
  };

  if (patient.signature_image) {
    const pngImageBytes = Uint8Array.from(atob(patient.signature_image), (c) =>
      c.charCodeAt(0)
    );
    const pngImage = await pdfDoc.embedPng(pngImageBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    firstPage.drawImage(pngImage, {
      x: 420, // ← adjust these coords as needed
      y: 110, // ← adjust height to position signature
      width: 150, // ← size of signature
      height: 45,
    });
  }

  for (const [f, v] of Object.entries(fieldsMap)) {
    const pdfField = field(f);
    if (pdfField) pdfField.setText(v?.toString() || "");
  }

  form.flatten();

  const pdfBytes = await pdfDoc.save();
  if (returnBlob) return pdfBytes;

  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  window.open(URL.createObjectURL(blob), "_blank");
};

export const handleDownloadConsentPDF = async (patient, returnBlob = false) => {
  try {
    const formUrl = "/hybrid-consent.pdf";
    const existingPdfBytes = await fetch(formUrl).then((res) =>
      res.arrayBuffer()
    );
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const form = pdfDoc.getForm();

    const nameField = form.getTextField("txt_45");
    const idField = form.getTextField("txt_24");
    const emailField = form.getTextField("txt_76");
    const contactField = form.getTextField("txt_63");

    const signed_at = form.getTextField("txt_64");
    const signed_day = form.getTextField("txt_61");
    const signed_month = form.getTextField("txt_89");
    const signed_year = form.getTextField("txt_26");

    nameField.setText(
      `${patient.patient_full_names} ${patient.patient_surname}`
    );
    idField.setText(patient.patient_identification_number || "");
    emailField.setText(patient.patient_email_address || "");
    contactField.setText(patient.patient_cell_number || "");

    // Get today's date
    const today = new Date();
    const day = String(today.getDate());
    const month = today.toLocaleString("default", { month: "long" });
    const year = String(today.getFullYear()).slice(-2); // Last 2 digits

    signed_at.setText("Groenkloof");
    signed_day.setText(day);
    signed_month.setText(month);
    signed_year.setText(year);

    if (patient.signature_image) {
      const pngImageBytes = Uint8Array.from(
        atob(patient.signature_image),
        (c) => c.charCodeAt(0)
      );
      const pngImage = await pdfDoc.embedPng(pngImageBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[1];

      firstPage.drawImage(pngImage, {
        x: 80, // ← adjust these coords as needed
        y: 405, // ← adjust height to position signature
        width: 130, // ← size of signature
        height: 32,
      });
    }

    form.flatten();

    const pdfBytes = await pdfDoc.save();
    if (returnBlob) return pdfBytes;

    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    window.open(URL.createObjectURL(blob), "_blank");
  } catch (error) {
    console.error("Error generating consent form PDF:", error);
  }
};

export const handleDownloadBillingPDF = async (patient, returnBlob = false) => {
  try {
    const formUrl = "/dr-pretorius-kamer-info-2025.pdf";
    const existingPdfBytes = await fetch(formUrl).then((res) =>
      res.arrayBuffer()
    );
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const form = pdfDoc.getForm();

    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}/${String(
      today.getMonth() + 1
    ).padStart(2, "0")}/${today.getFullYear()}`;

    const nameField = form.getTextField("txt_22");
    const SurnameField = form.getTextField("txt_4");
    const IDField = form.getTextField("txt_88");
    const contactnumberField = form.getTextField("txt_80");
    const emailField = form.getTextField("txt_73");
    const address1Field = form.getTextField("txt_59");
    const address2Field = form.getTextField("txt_69");
    const address3Field = form.getTextField("txt_90");
    const addresscodeField = form.getTextField("txt_48");
    const medical_aid_name_Field = form.getTextField("txt_83");
    const medical_aid_plan_Field = form.getTextField("txt_97");
    const medical_aid_num_Field = form.getTextField("txt_9");
    const medical_aid_dep_Field = form.getTextField("txt_56");
    const dateField = form.getTextField("txt_99");
    dateField.setText(formattedDate);

    nameField.setText(patient.main_full_names || "");
    SurnameField.setText(patient.main_surname || "");
    IDField.setText(patient.main_identification_number || "");
    contactnumberField.setText(patient.main_cell_number || "");
    emailField.setText(patient.main_email_address || "");
    address1Field.setText(patient.main_postal_address_1 || "");
    address2Field.setText(patient.main_postal_address_2 || "");
    address3Field.setText(patient.main_postal_address_3 || "");
    addresscodeField.setText(patient.main_postal_address_code || "");
    medical_aid_name_Field.setText(patient.main_medical_scheme || "");
    medical_aid_plan_Field.setText(patient.main_medical_scheme_plan || "");
    medical_aid_num_Field.setText(patient.main_medical_member_number || "");
    medical_aid_dep_Field.setText(
      patient.main_medical_member_main_dep_code || "",
      dateField.setText(formattedDate)
    );

    if (patient.signature_image) {
      const pngImageBytes = Uint8Array.from(
        atob(patient.signature_image),
        (c) => c.charCodeAt(0)
      );
      const pngImage = await pdfDoc.embedPng(pngImageBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];

      firstPage.drawImage(pngImage, {
        x: 120, // ← adjust these coords as needed
        y: 148, // ← adjust height to position signature
        width: 110, // ← size of signature
        height: 28,
      });
    }

    form.flatten();

    const pdfBytes = await pdfDoc.save();
    if (returnBlob) return pdfBytes;

    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    window.open(URL.createObjectURL(blob), "_blank");
  } catch (error) {
    console.error("Error generating consent form PDF:", error);
  }
};

export const handleDownloadCombinedPDF = async (
  patient,
  returnBlob = false
) => {
  try {
    const [detailBytes, consentBytes, billingBytes] = await Promise.all([
      handleDownloadPrefilledPDF(patient, true),
      handleDownloadConsentPDF(patient, true),
      handleDownloadBillingPDF(patient, true),
    ]);

    const combinedPdf = await PDFDocument.create();

    const detailDoc = await PDFDocument.load(detailBytes);
    const consentDoc = await PDFDocument.load(consentBytes);
    const billingDoc = await PDFDocument.load(billingBytes);

    const copyPages = async (srcDoc) => {
      const pages = await combinedPdf.copyPages(
        srcDoc,
        srcDoc.getPageIndices()
      );
      pages.forEach((page) => combinedPdf.addPage(page));
    };

    await copyPages(detailDoc);
    await copyPages(consentDoc);
    await copyPages(billingDoc);

    const combinedBytes = await combinedPdf.save();
    if (returnBlob) return combinedBytes;

    const blob = new Blob([combinedBytes], { type: "application/pdf" });
    const date = new Date();
    const timestamp = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}-${String(
      date.getHours()
    ).padStart(2, "0")}${String(date.getMinutes()).padStart(2, "0")}`;
    const filename = `${patient.request_number}_ALL_FORMS_${patient.patient_surname}_${timestamp}.pdf`;

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error("Failed to generate combined PDF:", error);
  }
};

export const handleViewCombinedPDF = async (patient) => {
  try {
    const pdfBlob = await handleDownloadCombinedPDF(patient, true);
    const blob = new Blob([pdfBlob], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
  } catch (err) {
    console.error("Failed to view combined PDF:", err);
  }
};

export const handleDownloadAneasthetistPDF = async (
  patient,
  returnBlob = false
) => {
  const formUrl = "/aneasthetist-form.pdf";
  const existingPdfBytes = await fetch(formUrl).then((res) =>
    res.arrayBuffer()
  );
  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const form = pdfDoc.getForm();

  const field = (name) => {
    try {
      return form.getTextField(name);
    } catch {
      return null;
    }
  };

  //const today = new Date();
  /*const formattedDate = `${String(today.getDate()).padStart(2, "0")}/${String(
    today.getMonth() + 1
  ).padStart(2, "0")}/${String(today.getFullYear()).slice(-2)}`;*/

  if (!patient) return;

  const fieldsMap = {
    /*txt_98: formattedDate,
    txt_19: formattedDate,*/
    txt_25: patient?.patient_surname || "",
    txt_48: patient?.patient_full_names || "",
    txt_41: (formatDateOnly(patient?.patient_date_of_birth) || "").substring(
      0,
      10
    ),
    txt_10: patient?.main_medical_scheme || "",
    txt_21: patient?.main_medical_scheme_plan || "",
    txt_14: patient?.main_medical_member_number || "",
    txt_50: patient?.main_surname || "",
    txt_97: patient?.main_title || "",
    txt_39: (patient.main_initials || "").substring(0, 4),
    txt_90: patient?.main_postal_address_1 || "",
    txt_89: patient?.main_postal_address_2 || "",
    txt_18: patient?.main_postal_address_3 || "",
    txt_93: patient?.main_postal_address_code || "",
    txt_76: (patient?.main_identification_number || "").substring(0, 13),
    txt_63: patient?.main_cell_number || "",
    txt_12: patient?.main_home_number || "",
    txt_82: patient?.main_work_number || "",
    txt_17: patient?.main_fax_number || "",
    txt_52: patient?.main_physical_address_1 || "",
    txt_86: patient?.main_physical_address_2 || "",
    txt_80: patient?.main_physical_address_3 || "",
    txt_46: patient?.main_email_address || "",
    txt_34: patient?.next_kin_full_names || "",
    txt_67: patient?.next_kin_cell_number || "",

    yes_no_01: patient?.anea_bit_01 ? "Yes" : "No",
    text_68xub: patient?.anea_detail_01 || "",
    text_43flic: patient?.anea_bit_02 ? "Yes" : "No",
    text_69ypbt: patient?.anea_detail_02 || "",
    text_44mvna: patient?.anea_bit_03 ? "Yes" : "No",
    text_70sfbh: patient?.anea_detail_03 || "",
    text_45ultl: patient?.anea_bit_04 ? "Yes" : "No",
    text_71hhwd: patient?.patient_weight || "",
    text_72molr: patient?.patient_height || "",
    text_46hjkj: patient?.anea_bit_05 ? "Yes" : "No",
    text_73maok: patient?.anea_detail_05 || "",
    text_47usbf: patient?.anea_bit_06 ? "Yes" : "No",
    text_74qndl: patient?.anea_detail_06 || "",
    text_48ecpi: patient?.anea_bit_07 ? "Yes" : "No",
    text_75hmkq: patient?.anea_detail_07 || "",
    text_49mngg: patient?.anea_bit_08 ? "Yes" : "No",
    text_76eze: patient?.anea_detail_08 || "",
    text_50lccf: patient?.anea_bit_09 ? "Yes" : "No",
    text_77aaim: patient?.anea_detail_09 || "",
    text_51nhlt: patient?.anea_bit_10 ? "Yes" : "No",
    text_78oeqk: patient?.anea_detail_10 || "",
    text_52omwc: patient?.anea_bit_11 ? "Yes" : "No",
    text_79rufp: patient?.anea_detail_11 || "",
    text_53likg: patient?.anea_bit_12 ? "Yes" : "No",
    text_80dymz: patient?.anea_detail_12 || "",
    text_54tamj: patient?.anea_bit_13 ? "Yes" : "No",
    text_81suqg: patient?.anea_detail_13 || "",
    text_55gohu: patient?.anea_bit_14 ? "Yes" : "No",
    text_82kqcx: patient?.anea_detail_14 || "",
    text_56qhcu: patient?.anea_bit_15 ? "Yes" : "No",
    text_83jvzz: patient?.anea_detail_15 || "",
    text_57ndsw: patient?.anea_bit_16 ? "Yes" : "No",
    text_84jhrn: patient?.anea_detail_16 || "",
    text_58cuer: patient?.anea_bit_17 ? "Yes" : "No",
    text_85nxrm: patient?.anea_detail_17 || "",
    text_59ksme: patient?.anea_bit_18 ? "Yes" : "No",
    text_86pups: patient?.anea_detail_18 || "",
    text_60ontp: patient?.anea_bit_19 ? "Yes" : "No",
    text_87tiff: patient?.anea_detail_19 || "",
    text_61kgel: patient?.anea_bit_20 ? "Yes" : "No",
    text_88avtl: patient?.anea_detail_20 || "",
    text_62braj: patient?.anea_bit_21 ? "Yes" : "No",
    text_89boty: patient?.anea_detail_21 || "",
    text_63kdfh: patient?.anea_bit_22 ? "Yes" : "No",
    text_90kzrs: patient?.anea_detail_22 || "",
    text_64ubmg: patient?.anea_bit_23 ? "Yes" : "No",
    text_91jmff: patient?.anea_detail_23 || "",
    text_65aibt: patient?.anea_bit_24 ? "Yes" : "No",
    text_92pdug: patient?.anea_detail_24 || "",
    text_66mbtd: patient?.anea_bit_25 ? "Yes" : "No",
    text_67ghoa: patient?.anea_bit_26 ? "Yes" : "No",
    text_93qfih: patient?.anea_detail_26 || "",
  };

  for (const [f, v] of Object.entries(fieldsMap)) {
    const pdfField = field(f);
    if (pdfField) pdfField.setText(v?.toString() || "");
  }

  form.flatten();

  const pdfBytes = await pdfDoc.save();
  if (returnBlob) return pdfBytes;

  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  window.open(URL.createObjectURL(blob), "_blank");
};
